package com.essntl.features.category.ui.addeditcategory

import com.essntl.features.category.domain.model.CategoryModel

sealed interface AddEditCategoryEvent {
    data class GetCategory(val id: String) : AddEditCategoryEvent
    data object GetCategoryIcons : AddEditCategoryEvent
    data class UpdateCategoryFields(val category: CategoryModel) : AddEditCategoryEvent
    data object AddCategory : AddEditCategoryEvent
    data object EditCategory : AddEditCategoryEvent
    data object DeleteCategory : AddEditCategoryEvent
    data object ClearState : AddEditCategoryEvent
}